// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OptionMenu__container___233Xy{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}@media (min-width:720px){.OptionMenu__container___233Xy{flex-direction:row}}.OptionMenu__item____u52U{display:flex;align-items:center;justify-content:center;width:80vw;max-width:327px;height:110px;margin:12px 0;border:2px solid #eae9e3;border-radius:8px;font-size:20px;cursor:pointer}@media (min-width:720px){.OptionMenu__item____u52U{width:220px;height:128px;margin:12px}}.OptionMenu__isSelected___3wzc8{border-color:#2d50e6;box-shadow:0 0 0 4px #d6e3fd}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "OptionMenu__container___233Xy",
	"item": "OptionMenu__item____u52U",
	"isSelected": "OptionMenu__isSelected___3wzc8"
};
module.exports = ___CSS_LOADER_EXPORT___;
